export default {
  cartons: {
    label: 'Souhaitez-vous que les déménageurs vous fournissent des cartons ?',
    options: {
      no: 'Non, j\'aurai mes propres cartons',
    },
  },
  wardrobesBox: {
    label: 'Souhaitez-vous qu\'ils prévoient des cartons penderies pour vos vêtements sur cintres ?',
    options: {
      no: 'Non, je les plierai dans des cartons',
    },
  },
  mount: {
    label: 'Souhaitez-vous qu\'ils démontent et remontent les meubles qui le nécessitent ?',
    options: {
      no: 'Non, je le ferai moi même',
    },
  },
  fragile: {
    label: 'Souhaitez-vous qu\'ils emballent et déballent vos objets fragiles ?',
    options: {
      no: 'Non, je le ferai moi même',
    },
  },
  notFragile: {
    label: 'Souhaitez-vous qu’ils emballent tous vos objets non-fragiles ?',
    options: {
      no: 'Non, je le ferai moi même',
    },
  },
};
